import Service from '@/api/Service'
import { DefaultMenu, AsyncMenu} from '@/menuConfig'
import { asyncRouterMap } from '@/router/router'    //  默认路由
import routeList from '@/router/module/routeList'    //  其他全部路由

import { getRoles, getEditRoles } from '@/utils/array.js'

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
    if (route.meta && route.meta.role) {
        return roles.indexOf(route.meta.role) >= 0
    } else {
        return true
    }
}

// 通过role左侧菜单
function hasMenuPermission(roles, menuItem) {
    if (menuItem.role) {
        return roles.indexOf(menuItem.role) >= 0
    } else {
        return true
    }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(routeList, roles) {
    const accessedRouters = routeList.filter(route => {
        if (hasPermission(roles, route)) {
            if (route.children && route.children.length) {
                route.children = filterAsyncRouter(route.children, roles)
            }
            return true
        }
        return false
    })
    return accessedRouters
}

/**
 *  过滤左侧菜单栏
 * @param {*} menus
 * @param {*} roles
 */
function filterMenu(menus, roles) {
    const accessedMenu = menus.filter(v => {
        if (hasMenuPermission(roles, v)) {
            if (v.subs && v.subs.length) {
                v.subs = filterMenu(v.subs, roles)
            }
            return true
        }
        return false
    })
    return accessedMenu
}

const user = {
    state: {
        user: {},
        roles: [],  //  路由权限
        editRole: {},
        mune: DefaultMenu,
    },
    mutations: {
        SET_USERINFO: (state, user) => {
            state.user = user
        },
        // 路由权限
        SET_ROLES: (state, roles) => {
            state.roles = roles
        },
        // 权限明细
        SET_EDITROLE: (state, editRole) => {
            state.editRole = editRole
        },
        SET_MUNE: (state, addMune) => {
            state.mune = addMune
        },
    },
    actions: {
        // 获取用户信息
        async GetUserInfo({ commit }) {
            // 如果存在用户信息直接返回
            let data = await Service.userInfo();
            return new Promise((resolve, reject) => {
                if (data){
                    resolve(data);
                    commit('SET_USERINFO', data);
                } else {
                    localStorage.clear();
                    reject('请重新登录')
                }
            })
        },
        // 获取权限路由
        async GenerateRoutes({ commit, state }, usertype) {
            let data;   //  动态路由表
            let navMunu;    //  左侧菜单栏
            if (usertype === 4) {
                // 子账号
                let editRole = getEditRoles(JSON.parse(state.user.group_allowed));
                let roles = getRoles(JSON.parse(state.user.group_allowed));
                if(roles.length) {
                    commit('SET_ROLES', roles);
                    commit('SET_EDITROLE', editRole);
                }
                // 过滤左侧菜单
                let asyncMenu = filterMenu(DefaultMenu, roles)
                // 过滤可访问的路由
                let filterRouter = filterAsyncRouter(routeList, roles);
                data = [
                    ...filterRouter,
                    ...asyncRouterMap,
                ]
                // navMunu = state.mune;   //  左侧菜单
                navMunu = asyncMenu;
            } else if (usertype === 3) {
                // 公司账号
                data = [
                    ...routeList,
                    ...asyncRouterMap,
                ]
                navMunu = state.mune;
            } else if (usertype === 2) {
                // 测试账号     **暂时跟公司账号权限一直**
                data = [
                    ...routeList,
                    ...asyncRouterMap,
                ]
                navMunu = state.mune;   //  左侧菜单
            } else {
                // 超级管理员
                data = [
                    ...routeList,
                    ...asyncRouterMap,
                ];
                navMunu = state.mune.concat(AsyncMenu); //  左侧菜单
            }
            return new Promise((resolve, reject) => {
                if (data) {
                    resolve(data);
                    commit('SET_MUNE', navMunu);
                } else {
                    reject('获取权限失败')
                }
            })
        },
        // 登出
        async LogOut({ commit }) {
            let data = await Service.logout();
            return new Promise((resolve, reject) => {
                if (data) {
                    commit('SET_USERINFO', {})
                    commit('SET_ROLES', []);
                    commit('SET_MUNE', DefaultMenu);
                    localStorage.clear();
                    resolve()
                }else{
                    reject()
                }
            })
        },
        // 清空路由信息
        async ClearUser({ commit }) {
            commit('SET_USERINFO', {})
            commit('SET_ROLES', []);
            commit('SET_MUNE', DefaultMenu);
            localStorage.clear();
        },
    }
}

export default user
